import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Icon, Tooltip, useBreakpoints } from "@qgiv/core-react";
import {
    FormikCheckbox,
    MoreInfoModal,
    CheckboxWithTooltip,
    useHover,
} from "@qgiv/core-donor";
import "./GiftAssist.scss";
import { useField } from "formik";

// Toggles the markup of the gift assist label based on whether or not gift
// assist is checked
const GiftAssistLabel = ({ renderGiftAssistLabel }) => (
    <>{renderGiftAssistLabel()}</>
);
GiftAssistLabel.propTypes = {
    renderGiftAssistLabel: PropTypes.func.isRequired,
};

const GiftAssist = ({
    displayGiftAssist = true,
    Gift_Assist,
    renderGiftAssistLabel,
    updateRegistrationGiftAssist,
    dispatch,
}) => {
    // This determines whether we use Tooltip or MoreInfoModal
    const { isSmallScreen } = useBreakpoints();

    const deviceHasHover = useHover();

    const formikProps = {
        name: "Gift_Assist",
        type: "checkbox",
        // validate,
    };
    const [{ onBlur, onChange, ...field }] = useField(formikProps);
    const fieldProps = {
        handleBlur: onBlur,
        handleChange: onChange,
        ...field,
    };

    useEffect(() => {
        // -------------------------------------------------------------------------
        // NOTE: We are going to need to start tracking Gift Assist in state
        //       so that we can use an update component to calculate the registration
        //       total amount, which is going to live outside of the formik form
        // -------------------------------------------------------------------------
        dispatch(updateRegistrationGiftAssist(Gift_Assist));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Gift_Assist]);

    const label = renderGiftAssistLabel();
    return (
        displayGiftAssist &&
        (deviceHasHover ? (
            <div className="col col--12">
                <div className="-callout -padding-top--0 -padding-bottom--0">
                    <FormikCheckbox id="Gift-Assist" name="Gift_Assist">
                        <GiftAssistLabel
                            renderGiftAssistLabel={renderGiftAssistLabel}
                        />
                        {isSmallScreen ? (
                            <span className="-padding-left--10">
                                <MoreInfoModal>
                                    Help cover the service, transaction, and
                                    credit card fees that come with donating
                                    online.
                                </MoreInfoModal>
                            </span>
                        ) : (
                            <Tooltip
                                placement="right"
                                content="Help cover the service, transaction, and credit card fees that come with donating online."
                                theme="dark"
                            >
                                <Icon
                                    className="-margin-left--5"
                                    glyph="question-circle-regular"
                                    type="FontAwesome"
                                />
                            </Tooltip>
                        )}
                    </FormikCheckbox>
                </div>
            </div>
        ) : (
            <div className="col col--12">
                <div className="-callout -padding-top--0 -padding-bottom--0">
                    <CheckboxWithTooltip
                        {...fieldProps}
                        name="Gift_Assist"
                        id="Gift-Assist"
                        label={label}
                        tooltipContent="Help cover the service, transaction, and credit card fees that come with donating online."
                    />
                </div>
            </div>
        ))
    );
};

GiftAssist.propTypes = {
    displayGiftAssist: PropTypes.bool.isRequired,
    Gift_Assist: PropTypes.bool.isRequired,
    renderGiftAssistLabel: PropTypes.func.isRequired,
    updateRegistrationGiftAssist: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
};

export default GiftAssist;
